export default __webpack_public_path__ + "static/world-map-1dd818e3441d9657fd3232450fb15a92.png";